import {
  Button,
  DatePicker,
  Input,
  Modal,
  Pagination,
  Select,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "wouter";
import { getQueryParams } from "../../utilities/getQueryParams";
import CommonAdminTable from "../components/commonTable";
import {
  TopDealersAPI,
  TopDealersExportAPI,
} from "../../redux/actions/adminActions/analysisActions";
const { Title } = Typography;
const TopDealers = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    document.title = "Order Requests: ALP Shop";
  }, []);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalData, setTotalData] = useState(1);
  console.log("totalData: ", totalData);
  const [searchValue, setSearchValue] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [sortBy, setSortBy] = useState("highest");
  const [colsName, setColsName] = useState();
  const currentYear = dayjs();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedQuarter, setSelectedQuarter] = useState();
  const [exportModal, setExportModal] = useState(false);

  console.log("setColsName: ", colsName);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/analysis/top-dealers?page=${page}`);
  };
  useEffect(() => {
    dispatch(
      TopDealersAPI({
        year: selectedYear.year(),
        quarter: Number(selectedQuarter),
        sort: sortBy,
        page: currentPage,
        perPage: 10,
      }),
    ).then((res) => {
      setTotalData(res?.payload?.data?.pagination?.total);
      setDataSource(res?.payload?.data?.data);
      setColsName(res?.payload?.data?.comparison);
    });
  }, [dispatch, currentPage, sortBy, selectedYear, selectedQuarter]);
  const columns = [
    {
      title: "Dealer Code",
      dataIndex: "dealer_code",
      key: "dealer_code",
      align: "center",
      render: (text) => {
        return text.toUpperCase();
      },
    },
    {
      title: "Dealer Name",
      dataIndex: "dealer_name",
      key: "dealer_name",
    },
    {
      title: `${
        colsName?.quarter2
          ? `${colsName?.year2} (Q${colsName?.quarter2})`
          : colsName?.year2
      } Order Value`,
      dataIndex: "order_value_period2",
      key: "order_value_period2",
      align: "center",
    },
    {
      title: `${
        colsName?.quarter1
          ? `${colsName?.year1} (Q${colsName?.quarter1})`
          : colsName?.year1
      } Order Value`,
      dataIndex: "order_value_period1",
      key: "order_value_period1",
      align: "center",
    },
    {
      title: "Variation",
      //   dataIndex: "variation",
      key: "variation",
      align: "center",
      render: (record) => {
        return (
          <p className={`${record.variation < 0 ? "text-red-600" : ""} `}>
            {record.variation}
          </p>
        );
      },
    },
  ];
  const exportData = () => {
    dispatch(
      TopDealersExportAPI({
        year: selectedYear.year(),
        quarter: Number(selectedQuarter),
        sort: sortBy,
      }),
    )
      .then((res) => {
        const csvData = res?.payload?.data;

        if (!csvData) {
          console.error("No data received");
          return;
        }

        let comparison = null;
        let year1 = null;
        let year2 = null;
        let quarter1 = null;
        let quarter2 = null;

        if (csvData) {
          // Split first line (header row)
          const firstLine = csvData.split("\n")[0];

          // Convert CSV → array
          const values = firstLine.split(",");

          // Clean quotes
          const cleaned = values.map((v) => v.replace(/"/g, "").trim());

          // Extract values based on positions
          comparison = cleaned[0]; // "Comparison"
          year1 = cleaned[2]; // 2026
          year2 = cleaned[4]; // 2025
          quarter1 = cleaned[6]; // 1
          quarter2 = cleaned[8]; // 4
        }

        console.log({ comparison, year1, year2, quarter1, quarter2 });

        const newHeader = `Comparison: ${year1} Quarter ${quarter1} and ${year2} Quarter ${quarter2}`;

        // 🛠 Modify CSV
        const lines = csvData.split("\n");
        lines[0] = newHeader; // replace first row
        const updatedCsv = lines.join("\n");

        // Create Blob
        const blob = new Blob([updatedCsv], {
          type: "text/csv;charset=utf-8;",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `top-dealers-${year1}-quarter-${quarter1}.csv`,
        );

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.log(err);
      });

    setExportModal(false);
  };
  return (
    <>
      <div className="flex justify-between items-center">
        <Title level={2} className="text-left">
          Top Performing Dealer(s)
        </Title>
        <div className="flex gap-2 items-center">
          {/* <label className="font-semibold">Year:</label> */}
          <DatePicker
            picker="year"
            className="rounded-md"
            placeholder="Year"
            allowClear={false}
            value={selectedYear}
            onChange={(value) => setSelectedYear(value)}
          />
          <Select
            className="w-[150px] [&_.ant-select-selector]:rounded-md"
            allowClear
            placeholder="Quarter(optional)"
            onChange={(value) => setSelectedQuarter(value)}
            options={[
              { label: "Quarter 1", value: "1" },
              { label: "Quarter 2", value: "2" },
              { label: "Quarter 3", value: "3" },
              { label: "Quarter 4", value: "4" },
            ]}
          />
          {/* </div>
        <div className="flex flex-col gap-2 items-center"> */}
          {/* <label className="font-semibold">Sort By:</label> */}

          <Select
            className="w-[150px] [&_.ant-select-selector]:rounded-md"
            placeholder="Sort By"
            value={sortBy}
            onChange={(value) => {
              setSortBy(value);
              setCurrentPage(1);
              navigate(`/admin/analysis/top-dealers?page=${1}`);
            }}
            options={[
              {
                label: "Growth",
                value: "highest",
              },
              {
                label: "Decline",
                value: "lowest",
              },
            ]}
          />
          <Button
            type="primary"
            className="rounded-md"
            onClick={() => setExportModal(true)}
          >
            EXPORT
          </Button>
        </div>
      </div>

      <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        {/* <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div> */}
      </div>
      <CommonAdminTable columns={columns} data={dataSource} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalData}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <Modal
        open={exportModal}
        onCancel={() => setExportModal(false)}
        onOk={exportData}
      >
        <div>
          <Title level={2} className="text-left">
            Top Performing Dealer(s)
          </Title>
          <div className="flex gap-2 items-center">
            {/* <label className="font-semibold">Year:</label> */}
            {/* <DatePicker
              picker="year"
              className="rounded-md"
              placeholder="Year"
              onChange={(value) =>
                setSelectedYear(new Date(value).getFullYear())
              }
            /> */}
            <DatePicker
              picker="year"
              className="rounded-md"
              placeholder="Year"
              allowClear={false}
              value={selectedYear}
              onChange={(value) => setSelectedYear(value)}
            />
            <Select
              className="w-[150px] [&_.ant-select-selector]:rounded-md"
              //   style={{ borderRadius: "6px!important" }}
              allowClear
              placeholder="Quarter(optional)"
              value={selectedQuarter}
              onChange={(value) => setSelectedQuarter(value)}
              options={[
                { label: "Quarter 1", value: "1" },
                { label: "Quarter 2", value: "2" },
                { label: "Quarter 3", value: "3" },
                { label: "Quarter 4", value: "4" },
              ]}
            />
            <Select
              className="w-[150px] [&_.ant-select-selector]:rounded-md"
              placeholder="Sort By"
              value={sortBy}
              onChange={(value) => {
                setSortBy(value);
                setCurrentPage(1);
              }}
              options={[
                {
                  label: "Highest Selling",
                  value: "highest",
                },
                {
                  label: "Lowest Selling",
                  value: "lowest",
                },
              ]}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
export default TopDealers;
